import { backendApi } from './api'

// Varslene i bjella. Alltid uten cache: et nytt varsel skal vises ved neste
// henting, og et lest varsel skal ikke komme tilbake som ulest.

export async function listNotifications() {
  const { data } = await backendApi.get('/notifications', { cache: false })
  return data
}

export async function getUnreadCount() {
  const { data } = await backendApi.get('/notifications/unread-count', { cache: false })
  return Number(data?.unread) || 0
}

export async function markNotificationRead(id) {
  const { data } = await backendApi.post(`/notifications/${id}/read`)
  return data
}

export async function markAllNotificationsRead() {
  const { data } = await backendApi.post('/notifications/read-all')
  return data
}
